import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ChatterlyLivePanel from "../components/ChatterlyLivePanel";
import { AuthContext } from "../App";

/**
 * Página dedicada de mensajería en tiempo real (Chatterly).
 * Ruta: /messages
 * Roles permitidos: admin, ceo, asistente, chatter (definido por el backend en /api/chatterly/*).
 */
export default function MessagesPage() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  // Ruta de regreso según rol
  const backHref =
    user?.role === "admin" || user?.role === "ceo"
      ? "/dashboard"
      : user?.role === "asistente"
      ? "/asistente"
      : "/empleado";

  return (
    <div className="h-screen overflow-hidden bg-[#050505] text-white flex flex-col">
      {/* Barra superior compacta */}
      <div className="flex-shrink-0 bg-black/70 backdrop-blur-md border-b border-white/5">
        <div className="max-w-[1600px] mx-auto px-4 py-2.5 flex items-center gap-3">
          <button
            onClick={() => navigate(backHref)}
            data-testid="messages-back-btn"
            className="flex items-center gap-1.5 text-xs text-gray-300 hover:text-white transition"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Volver
          </button>
          <div className="h-4 w-px bg-white/10" />
          <h1 className="text-sm font-semibold text-white">💬 Mensajería · Chatterly Live</h1>
          {user?.name && (
            <span className="ml-auto text-[10px] text-gray-400">
              Firmando como <span className="text-emerald-400">{user.name}</span>
            </span>
          )}
        </div>
      </div>

      {/* Contenido — ocupa el resto de la altura sin generar scroll global */}
      <div className="flex-1 min-h-0 max-w-[1600px] w-full mx-auto p-3 overflow-hidden">
        <ChatterlyLivePanel />
      </div>
    </div>
  );
}
